<script setup lang="ts">
// The app shell renders the auth layout until P2 wires the admin guard; every other screen
// arrives with P5.
</script>

<template>
  <RouterView />
</template>
